import { createElementBlock as o, openBlock as n, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return n(), o("svg", t, e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.011 20.99c1.124-.887 2.04-1.775 3.506-1.977 1.268 0 2.49.481 3.416 1.348a3.595 3.595 0 0 0 5.561-2.115 3.146 3.146 0 0 0 3.317-4.599 3.148 3.148 0 0 0 1.234-5.241 3.145 3.145 0 1 0-4.45-4.45 3.147 3.147 0 0 0-5.24 1.234 3.146 3.146 0 0 0-4.6 3.317 3.596 3.596 0 0 0-2.11 5.533c.714 1.035 1.532 2.197 1.344 3.444-.247 1.477-1.066 2.366-1.978 3.506m0 0L16.494 7.507"
    }, null, -1)
  ]));
}
const a = { render: l };
export {
  a as default,
  l as render
};
